<template>
  <div class="pb-3">
    <h3 class="pb-3">HOW WE CAN HELP YOU ?</h3>
    <form class="row" @submit.prevent>
        <base-column :col="6">
          <input type="text" placeholder="Your name">
        </base-column>
        <base-column :col="6">
          <input type="text" placeholder="Your Email">
        </base-column>
        <base-column>
          <input type="text" placeholder="Subject">
        </base-column>
        <base-column>
          <textarea rows="8" placeholder="Message"></textarea>
        </base-column>
        <base-column>
          <button-primary class="w-50">
            Submit
          </button-primary>
        </base-column>
    </form>
  </div>
</template>

<script>
export default {
  name: "ContactForm",
}
</script>

<style scoped>
  div {
    text-align: center;
  }
  input, textarea {
    width: 100%;
    margin-bottom: 30px;
    background-color: #f5f5f5;
    border: none;
    padding: 10px 20px;
  }
  input:focus, textarea:focus {
    outline: 0.15rem solid #f6483b;
  }
  input {
    height: 45px;
  }
  form {
    width: 100%;
    margin: 0;
  }
</style>